import { createSlice } from '@reduxjs/toolkit'


let response = await fetch('/config.json');
let configData = await response.json();

const initialState = await configData.BaseURL;

// Separate API host that serves the forgot-password (WhatsApp OTP) endpoints.
export const mobileApiBaseURL = configData.MobileApiBaseURL;

export const utilSlice = createSlice({
    name: 'baseURL',
    initialState,
    reducers: {
        initiate: (state) => {
            state.baseURL = null;
        }
    },
})

// Action creators are generated for each case reducer function
export const { initiate } = utilSlice.actions

export default utilSlice.reducer